import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	/** 서버가 준 상태 코드. VALID / NOT_STARTED / EXPIRED / INVALID / UNSUPPORTED */
	status: null,
	/** 읽어낸 라이선스 내용. UNSUPPORTED 면 null 이다 */
	license: null,
	// 파일이 스스로 말하는 형식. 구버전은 온라인 인증 대상이 되지 않아 화면이 보여 준다.
	format: null,
	fileName: null,
	loading: false,
	error: null,
};

/**
 * 파일 검증.
 *
 * <b>서버가 사람이 읽는 문구를 주지 않는다.</b> 상태 코드만 받고 문구는 화면이 i18n 으로
 * 만든다 — 예전 화면 API 는 한국어 문장을 그대로 실어 보냈고, 화면이 그 문자열을 비교했다.
 * 서버가 문구를 다듬는 순간 화면이 깨지는 구조였다.
 *
 * 결과를 저장해 두지 않는다. 파일을 다시 고르면 이전 결과가 남아 있으면 안 된다.
 */
export const validationSlice = createSlice({
	name: 'validation',
	initialState,
	reducers: {
		clearValidation: () => initialState,
		validateRequest: (state, action) => {
			state.loading = true;
			state.error = null;
			state.status = null;
			state.license = null;
			state.format = null;
			state.fileName = action.payload?.file?.name ?? null;
		},
		validateSuccess: (state, action) => {
			state.status = action.payload?.status ?? 'INVALID';
			state.license = action.payload?.license ?? null;
			state.format = action.payload?.format ?? null;
			state.loading = false;
		},
		validateFailure: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		},
	},
});

export const {
	clearValidation,
	validateRequest,
	validateSuccess,
	validateFailure,
} = validationSlice.actions;

export default validationSlice.reducer;
